import React from "react";
import { Loader2 } from "lucide-react";

export default function Spinner({
  size = 16,
  className = "",
  label = null,
}) {
  return (
    <span className="inline-flex items-center gap-2">
      <Loader2
        className={`animate-spin ${className}`}
        style={{ width: size, height: size }}
        aria-hidden="true"
      />
      {label ? <span className="text-sm">{label}</span> : null}
    </span>
  );
}
